import JobsFeed from "./jobsFeed"

export default JobsFeed
